<template>
  <div id="scroll-board" @click="routerIssueTop()">
    <div class="title">
      {{ title
      }}<dv-decoration-3 style="width:4rem; height: 30px; right: 50px; position: absolute" />
    </div>
    <dv-decoration-10 style="width: 300px; height: 5px" />
    <dv-scroll-board :config="config" />
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
export default {
  name: "ScrollBoard",
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
    title: {
      handler: function (val, oldVal) {
        this.title = val;
      },
      deep: true,
    },
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
    title: {
      type: String,
      default: function () {
        return "上周影响主要问题";
      },
    },
  },
  data() {
    return {
      datas: this.beans,
      config: {
        // header: ["产线", "发生时间", "问题描述", "持续时间(分钟)"],
        // data: [],
        // columnWidth: [100, 100, 130, 100],
        // align: ["center"],
        // rowNum: 3,
        // headerBGC: "rgba(10, 29, 50, 0.8)",
        // headerHeight: 30,
        // oddRowBGC: "rgba(0, 44, 81, 0.8)",
        // evenRowBGC: "rgba(10, 29, 50, 0.8)",
      },
    };
  },
  methods: {
    routerIssueTop() {
      this.$router.push({
        path: "/oee/issue-top"
      });
    },
    createData() {
      var dataList = this.datas;
      var data = [];
      for (var i = 0; i < dataList.length; i++) {
        var line = dataList[i]["line"];
        var device = dataList[i]["device"];
        var faiCode = dataList[i]["faiCode"];
        var faiCause = dataList[i]["faiCause"];
        var productName = dataList[i]["productName"];
        var duration = dataList[i]["duration"];

        if (dataList[i]["unCom"] < 1) {
          line = '<span style="color:#00E690">' + line + "</span>";
          device = '<span style="color:#00E690">' + device + "</span>";
          productName = '<span style="color:#00E690">' + productName + "</span>";
          faiCause = '<span style="color:#00E690">' + faiCause + "</span>";
          duration = '<span style="color:#00E690">' + duration + "</span>";
        }
        var value = [line, device, productName, faiCause, duration];
        data.push(value);
      }

      this.config = {
        header: ["产线", "设备", "产品", "故障说明", "持续时间(分)"],
        data: data,
        columnWidth: [130, 180, 150, 250, 130],
        align: ["left", "left", "left", "left", "center"],
        rowNum: 6,
        headerBGC: "rgba(6, 30, 93, 0.5)",
        headerHeight: 30,
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
      };
    },
    dateFormat(uninx) {
      return dateFormat(uninx, "MM-dd");
    },
  },
};
</script>

<style lang="less">
#scroll-board {
  width: 100%;
  box-sizing: border-box;
  margin-left: 10px;
  height: 50%;
  overflow: hidden;

  // margin-bottom:2%;
  .title {
    height: 30px;
    margin-bottom: 0px;
    font-weight: bold;
    text-indent: 20px;
    font-size: 20px;
    text-align: center;
    display: flex;
    align-items: center;
  }

  .header-item {
    font-weight: bold;
    font-size: 17px;
    text-shadow: 0 0 10px #fff,
      0 0 25px #33ccff,
  }

  .row-item {
    font-weight: bold;
    font-size: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/scrollBoard.vue